module.exports = __webpack_public_path__ + "img/dec1.5df51b81.jpg";